import React, { useEffect, useState } from 'react';
import SoundSwitch from './SoundSwitch';

interface InfoOverlayProps {
    visible: boolean;
}

// The name in the room, set like the loading screen's (Fraunces name, spaced Nunito role) but light, on the 3D.
// White name, the role in the site's orange under a short orange rule, and the sound switch below.

const InfoOverlay: React.FC<InfoOverlayProps> = ({ visible }) => {
    const [togglesVisible, setTogglesVisible] = useState(false);

    useEffect(() => {
        if (!visible || togglesVisible) return;
        const t = setTimeout(() => setTogglesVisible(true), 900);
        return () => clearTimeout(t);
    }, [visible]);

    return (
        <div className="room-brand">
            <div className="room-brand-rule" />
            <div className="room-brand-name">JAVIER GARCÍA</div>
            <div className="room-brand-role">GAME DEVELOPER</div>
            <div className={'room-brand-tools' + (togglesVisible ? ' is-on' : '')}>
                <SoundSwitch tone="light" />
            </div>
        </div>
    );
};

export default InfoOverlay;
